let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3yQyN")).then(() => parcelRequire('l4mr2'));